import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaGithub,
  FaGlobe,
  FaLink,
  FaResearchgate,
  FaOrcid
} from 'react-icons/fa';

import {
  SiGooglescholar,
  SiMedium,
  SiX,
  SiThreads
} from 'react-icons/si';

// Social media platform detection and icon mapping
export const getSocialMediaInfo = (url) => {
  if (!url) return null;
  
  const lowercaseUrl = url.toLowerCase();
  
  // Platform detection patterns
  const patterns = {
    facebook: {
      regex: /facebook\.com|fb\.com/,
      icon: FaFacebook,
      color: '#1877F2',
      name: 'Facebook'
    },
    twitter: {
      regex: /twitter\.com|x\.com/,
      icon: SiX,
      color: '#1DA1F2',
      name: 'X (Twitter)'
    },
    linkedin: {
      regex: /linkedin\.com/,
      icon: FaLinkedin,
      color: '#0077B5',
      name: 'LinkedIn'
    },
    instagram: {
      regex: /instagram\.com/,
      icon: FaInstagram,
      color: '#E4405F',
      name: 'Instagram'
    },
    youtube: {
      regex: /youtube\.com|youtu\.be/,
      icon: FaYoutube,
      color: '#FF0000',
      name: 'YouTube'
    },
    github: {
      regex: /github\.com/,
      icon: FaGithub,
      color: '#333333',
      name: 'GitHub'
    },
    googlescholar: {
      regex: /scholar\.google\.com/,
      icon: SiGooglescholar,
      color: '#4285F4',
      name: 'Google Scholar'
    },
    researchgate: {
      regex: /researchgate\.net/,
      icon: FaResearchgate,
      color: '#00CCBB',
      name: 'ResearchGate'
    },
    orcid: {
      regex: /orcid\.org/,
      icon: FaOrcid,
      color: '#A6CE39',
      name: 'ORCID'
    },
    medium: {
      regex: /medium\.com/,
      icon: SiMedium,
      color: '#000000',
      name: 'Medium'
    },
    threads: {
      regex: /threads\.net/,
      icon: SiThreads,
      color: '#000000',
      name: 'Threads'
    }
  };

  // Check each pattern
  for (const [platform, info] of Object.entries(patterns)) {
    if (info.regex.test(lowercaseUrl)) {
      return {
        icon: info.icon,
        color: info.color,
        name: info.name,
        url: url
      };
    }
  }

  // Default for unknown platforms
  return {
    icon: FaGlobe,
    color: '#666666',
    name: 'Website',
    url: url
  };
};
